module.exports = __webpack_public_path__ + "zl15-e58c3aad.png";